import React, {Component} from 'react'
import PassListScreen from '../screens/PassListScreen'
import SostaOnlineApiService from '../services/SostaOnlineApiService'
import {connect} from "react-redux";
import { normalize, schema } from 'normalizr';


const mapStateToProps = (state) => {
    return {
        state: state.auth
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch
    };
};

class PassListContainer extends Component {

    constructor(props) {
        super(props);
        this.unlisten = props.history.listen(this.onHistoryChange.bind(this));

        this.state = {
            user: {
                parkingPasses: []
            }
        };
    }

    componentDidMount() {
        this.fetchParkingPasses(this.getFilterFromLocation(this.props.location));
    }

    componentWillUnmount() {
        this.unlisten();
    }

    onHistoryChange(location, action) {
        this.fetchParkingPasses(this.getFilterFromLocation(location));
    }

    fetchParkingPasses(state) {
        SostaOnlineApiService.fetchUser(this.props.state.user.id).then(data => {
            this.setState({user: data.data});
        });
    }

    getFilterFromLocation(location) {
        let splittedPath = location.pathname.split("/");
        return splittedPath[splittedPath.length - 1];
    }

    render() {
        return(
            <PassListScreen parkingPasses={this.state.user.parkingPasses} />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PassListContainer);


// WEBPACK FOOTER //
// ./src/containers/PassListContainer.js